import { Form, Head } from "@inertiajs/react"
import { LoaderCircle } from "lucide-react"

import InputError from "@/components/input-error"
import TextLink from "@/components/text-link"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import AuthLayout from "@/layouts/auth-layout"
import { identityPasswordResetPath, signInPath } from "@/routes"

export default function ForgotPassword() {
  return (
    <AuthLayout
      title="Restablecer contraseña"
      description="Ingresa tu email para recibir un enlace de restablecimiento"
    >
      <Head title="Restablecer contraseña" />

      <div className="space-y-6">
        <Form method="post" action={identityPasswordResetPath()}>
          {({ processing, errors }) => (
            <>
              <div className="grid gap-2">
                <Label htmlFor="email">Correo electrónico</Label>
                <Input
                  id="email"
                  type="email"
                  name="email"
                  autoComplete="off"
                  placeholder="correo@ejemplo.com"
                />
                <InputError message={errors.email} />
              </div>

              <div className="my-6 flex items-center justify-start">
                <Button className="w-full" disabled={processing}>
                  {processing && (
                    <LoaderCircle className="h-4 w-4 animate-spin" />
                  )}
                  Enviar enlace de restablecimiento
                </Button>
              </div>
            </>
          )}
        </Form>
        <div className="text-muted-foreground space-x-1 text-center text-sm">
          <span>O volver a</span>
          <TextLink href={signInPath()}>iniciar sesión</TextLink>
        </div>
      </div>
    </AuthLayout>
  )
}
